import React, { useContext } from 'react';
import { css } from '@emotion/css';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DrainContext, DrainType } from 'contexts/DrainContext';
import { EMPTY_ELEMENT } from 'common/utils/react';

import SelectSorting from '../pages/store/sorting';
import { FilterTaxonomy, getFilterTaxonomyOptions } from 'api/queries/filter';

import { Color } from 'css/theme';

const DEFAULT_FILTER_PLACEHOLDER = 'Filter';

const classes = {
  root: css`
    position: relative;
    display: flex;
    flex-direction: row;
  `,
  icon: css`
    padding: 20px;
    position: absolute;
    right: 0;
    top: -9px;
    color: ${Color.Gray800};
  `,
  placeholder: css`
    ::placeholder {
      color: ${Color.Gray800};
    }
  `,
  input: css`
    border: 1px solid ${Color.Purple400};
  `,
};

type Props = {
  className: string;
  filterList?: FilterTaxonomy;
  type: DrainType;
};

export const FilterInput: React.FC<Props> = ({ className, filterList, type }) => {
  const drain = useContext(DrainContext);

  return (
    <div className={classNames([classes.root])}>
      <div className={classNames([className])}>
        {type === DrainType.Filter ? (
          <input
            name="search"
            value={void 0}
            placeholder={filterList.filter.title || DEFAULT_FILTER_PLACEHOLDER}
            className={classNames([
              'text-base bg-white h-12 pr-12 pl-6 lg:pl-6 sm:pl-6 outline-none focus:outline-none focus:shadow-sm w-full rounded-full',
              classes.placeholder,
              classes.input,
            ])}
            autoComplete="off"
            onClick={event => {
              event.currentTarget.blur();
              document.body.style.overflow = 'hidden';
              drain.switchFilter({ apply: false });
            }}
          />
        ) : (
          <SelectSorting
            hidden={!getFilterTaxonomyOptions(filterList).sort.switched}
            filterList={filterList}
            className="flex-1 relative"
          />
        )}
      </div>
      {type === DrainType.Filter ? (
        <div className={classes.icon}>
          <FontAwesomeIcon
            icon={['far', 'sliders-h']}
            onClick={event => {
              event.currentTarget.blur();
              document.body.style.overflow = 'hidden';
              drain.switchFilter({ apply: false });
            }}
          />
        </div>
      ) : (
        EMPTY_ELEMENT
      )}
    </div>
  );
};
